import BaseEvent from './base_event';
import * as effects from '../effects'
import * as ItemsFactory from '../../objects/items/items_factory';
import Fire from '../../objects/items/fire';
import BrownAlien from '../../objects/items/moveable/brown_alien';

export default class HungerEvent extends BaseEvent {

    static canOccur(gameState) {
        return !gameState.eventsResults.hunger;
    }

    enter(gameState) {
        gameState.eventsResults.hunger = true;

        let room = gameState.getRoomWhereHeroIs();

        this.ui.showDialog({
            message:
                `Boy you are hungry! Time to eat some hot food!`,
            options: [{
                text: `Order* Jenkins* to make some.`,
                condition: gameState.has('jenkins'),
                callback: () => {
                    gameState.addEnergy += 10;
                    this.ui.showDialog({
                        message: `Robot grunts something about meatbag oppression and makes you something suspiciously metallic with an oil aftertaste. You carefully drop it in a furnace, then scrape off your face from the opposite wall and remind yourself to use blast protection.`,
                        status: "+ 10% Energy"
                    }, this.end);
                }
            }, {
                text: `Make a fried egg. What could go wrong?`,
                callback: () => {
                    let dice_roll = game.rnd.frac();
                    let hasMadJenkins = gameState.has('madjenkins');
                    if (dice_roll < 0.4) {
                        gameState.items.add(new BrownAlien(gameState.hero.x, gameState.hero.y));
                        gameState.history.push({ id: 'food', msg: 'took a lesson in Giger\'s culinary school'});
                        this.ui.showDialog({
                            message: `Usually Jenkins makes the food for you, but ${hasMadJenkins ? "he is slightly mad now, so " : ""}it's time to grow up. Hm, are eggs supposed to be violet?\n*crack*`,
                            status: "OH MY GOD ITS ALIVE!",
                            options: [{text: "AAAAAAA!"}]
                        }, this.end);
                    } else if (dice_roll < 0.8) {
                        gameState.items.add(new Fire(gameState.hero.x, gameState.hero.y));
                        gameState.history.push({ id: 'food', msg: 'took a lesson in explosive culinary'});
                        this.ui.showDialog({
                            message: `Usually Jenkins makes the food for you, but ${hasMadJenkins ? "he is slightly mad now, so " : ""}it's time to grow up. Now, how does the oven work?..`,
                            status: "Fire alert!"
                        }, this.end);
                    } else {
                        gameState.history.push({ id: 'food', msg: 'made a mess on the kitchen'});
                        this.ui.showDialog({
                            message: `Apparently nothing. The eggs are pretty tasty! Kitchen is closed due to the radiation poisoning though. Don't ask.`
                        }, this.end);
                    }
                }
            }, {
                text: `It’s ok, I’ll just wait till the destination.`,
                callback: () => {
                    let dice_roll = game.rnd.frac();

                    if (dice_roll < 0.5) {
                        this.ui.showDialog({
                            message: `You calm down your stomach, and gaze upon the stars. They look like chicken.`
                        }, this.end);
                    } else {
                        gameState.history.push({ id: 'food', msg: 'passed out from hunger'});
                        gameState.distanceLeft += 3;
                        this.ui.showDialog({
                            message: `Hunger doesn’t end well for the pilots - you fall asleep right in the pilot chair, missing the nebula starway SW-51. You curse the nav computer and prepare for a U-turn.`,
                            status: "+3 Light Years"
                        }, this.end);
                    }
                }
            }]
        });
    }


}



// WEBPACK FOOTER //
// ./src/states/events/hunger.js